module.exports = __webpack_public_path__ + "static/media/icon_remove.50cc3285.svg";